import { useChatModel } from "../context";
import { ModelSelector } from "./model-selector";

/**
 * Connects the presentational `ModelSelector` to the chat model context so
 * `ChatPrompt` can render it without threading model state through props.
 */
export function ChatModelSelector() {
  const { models, selectedModel, setSelectedModel } = useChatModel();
  return (
    <ModelSelector
      models={models}
      onSelect={setSelectedModel}
      selectedModel={selectedModel}
    />
  );
}
